import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Flex } from '../../../GlobalComponents/Flex';
import { useDeleteCartItem } from '../../hooks/useDeleteCartItem';
import { useDuplicateCartItem } from '../../hooks/useDuplicateCartItem';
import { useEditCartItem } from '../../hooks/useEditCartItem';
import { Buttons } from '../Buttons/index';
import { CartImage } from '../CartImage';

export type CartItemProps = {
	name: string;
	id: string;
	productId: string;
	price: JSX.Element | string;
	modifiers: JSX.Element | string;
	checkIsItemEditable?: (id: string) => boolean;
};

export const CartItem: React.FC<CartItemProps> = ({
	name,
	id,
	productId,
	price,
	modifiers
}) => {
	const location = useLocation();
	const deleteCartItem = useDeleteCartItem();
	const duplicateCartItem = useDuplicateCartItem();
	const editCartItem = useEditCartItem();
	return (
		<CartItemContainer>
			<Flex
				$flexDirection="row"
				$placeContent="center space-between"
				$alignItems="center"
				$columnGap="15px"
			>
				<Flex $flexDirection="column" $rowGap="5px">
					<Link to={`/product/edit/${id}`}>
						<Flex $flexDirection="row" $columnGap="12px">
							<CartImage id={productId} name={name} />
							<Flex $flexDirection="column">
								<ProductName>{name}</ProductName>
								<Modifiers>{modifiers}</Modifiers>
							</Flex>
						</Flex>
					</Link>
				</Flex>
				<Price>${price}</Price>
			</Flex>
			{location.pathname.includes('cart') && (
				<Flex
					$flexDirection="row"
					$placeContent="center"
					$alignItems="center"
					$margin="5px 0 10px 0"
				>
					<Buttons
						id={id}
						onEdit={(id: string) => editCartItem(id)}
						onDuplicate={(id: string) => duplicateCartItem(id)}
						onDelete={(id: string) => deleteCartItem(id)}
					/>
				</Flex>
			)}
		</CartItemContainer>
	);
};

const ProductName = styled.div`
	font-weight: 500;
	font-size: 18px;
	color: #574d45;
`;

const Modifiers = styled.div`
	font-weight: 400;
	font-size: 12px;
	color: #574d45;
`;

const Price = styled.div`
	font-weight: 500;
	font-size: 18px;
	text-align: right;
`;

const CartItemContainer = styled.div`
	border-bottom: 0.3px rgba(87, 77, 69, 0.3) solid;
	margin: 10px -16px;
	padding: 10px;
`;
